import { useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';

import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL, ROLES } from '../../../../utils/constants';
import { CreatedOnCell } from '../../../../components/common/grid/Cells';
import { transformLabels } from '../../../../utils/misc';
import { FnbOrderGetWithItemsDto } from 'svila-common';
import PullFnbOrders from '../components/PullFnbOrders';
import GridWrapper from '~/src/components/common/GridWrapper';
import { InputFilterCell } from '~/src/components/common/grid/InputFilterCell';

export default function FnbStatus(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/fnb/get`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const NumberCell = (row) => {
    const { dataItem } = row;
    return (
      <td>
        <Link to={`/orders/fnb/${dataItem.uniqueNumber}`}>{dataItem.uniqueNumber}</Link>
      </td>
    );
  };

  const OrderNumberCell = (row) => {
    const { dataItem } = row;
    return <td>{dataItem?.order?.orderNumber}</td>;
  };

  const StatusCell = (row) => {
    const { dataItem } = row;
    return <td>{transformLabels(dataItem.statusTxt)}</td>;
  };

  const ReservationCell = (row): JSX.Element => {
    const { dataItem }: { dataItem: FnbOrderGetWithItemsDto } = row;

    return <td>{dataItem.fnbItemReservationStatus}</td>;
  };

  const PriceCell = (row) => {
    const { dataItem } = row;
    return <td>{`${dataItem.total} лв.`}</td>;
  };
  const ConsolidatedCell = (row) => {
    const { dataItem } = row;
    return <td>{dataItem.order?.consolidationParentOrder?.id ? 'Yes' : 'No'}</td>;
  };
  const ProblemCell = (row) => {
    const { dataItem } = row;
    let finalString = dataItem?.problem || '';
    if (dataItem?.fnbItemReservationStatus) {
      if (
        dataItem?.fnbItemReservationStatus === 'PartiallyReserved' ||
        dataItem?.fnbItemReservationStatus === 'NoneReserved'
      ) {
        finalString = finalString === '' ? 'Not enough quantities' : `\n Not enough quantities`;
      }
    }
    return <td>{finalString}</td>;
  };
  const UpdateTable = () => {
    stateRef?.current?.update();
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/home`);
        }}
        title="Packing FNB Orders"
      />
      <PullFnbOrders onUpdate={UpdateTable} />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="status" title="FNB Order" cell={StatusCell} />
          <GridColumn field="orderDate" title="Client" cell={CreatedOnCell} />
          <GridColumn field="uniqueNumber" title="KC Travel Order" cell={NumberCell} />
          <GridColumn field="uniqueNumber" title="Order Number" cell={OrderNumberCell} />
          <GridColumn field="isPacked" title="Packed" />
          <GridColumn field="name" title="Клиент" />
          <GridColumn field="nameLast" title="Клиент" />
          <GridColumn field="paymentMethodTxt" title="Метод на плащане" />
          <GridColumn field="shCityName" title="Град за доставка" />
          <GridColumn field="total" title="Сума" cell={PriceCell} />
          <GridColumn title="Reservation" cell={ReservationCell} />
          <GridColumn field="problem" title="Problem" cell={ProblemCell} />
          <GridColumn field="consolidated" title="Consolidated" cell={ConsolidatedCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
